import React from "react";
import { BtnWhite, BtnOutline } from "../ui/Buttons";

const CTABanner = ({ navigate, title, sub, btn1 = "Get a Free Consultation", btn2 = "Watch a Demo", page1 = "contact", page2 = "demo" }) => (
  <section className="py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="relative overflow-hidden bg-gradient-to-br from-blue-600 to-blue-500 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
        {/* decorative circle */}
        <span className="absolute -top-20 -right-20 w-72 h-72 bg-white/5 rounded-full pointer-events-none" />
        <span className="absolute -bottom-12 -left-12 w-48 h-48 bg-white/5 rounded-full pointer-events-none" />

        <div className="relative text-center md:text-left">
          <h2 className="font-head font-extrabold text-2xl md:text-3xl text-white mb-2">
            {title || "Ready to Transform Your Business with AI?"}
          </h2>
          <p className="text-white/70 text-base">
            {sub || "Free consultation — no commitment required."}
          </p>
        </div>

        <div className="flex flex-wrap gap-3 relative justify-center md:justify-end">
          {btn1 && <BtnWhite onClick={() => navigate(page1)}>{btn1}</BtnWhite>}
          {btn2 && <BtnOutline onClick={() => navigate(page2)}>{btn2}</BtnOutline>}
        </div>
      </div>
    </div>
  </section>
);

export default CTABanner;
